module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sitefooter":{"link1":"About This Report","link2":"Schneider Sustainability Impact","link3":"Data Privacy"}},"fr":{"sitefooter":{"link1":"A propos de ce rapport","link2":"Impact de Schneider sur le développement durable","link3":"La confidentialité des données"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Footer.vue
// module id = 9uhx
// module chunks = 0